













import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import CustomContactField from '@shared/components/forms/inputs/custom-contact-field/custom-contact-field.vue';
import { CustomContactFieldInterface } from '@contacts/interfaces/custom-contact-field';

@Component({
  name: 'bpc-custom-contact-fields-input',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'bpc-custom-contact-field': CustomContactField,
  },
})
export default class CustomContactFieldsInput extends mixins(AbstractField) {
  @Prop({ type: Boolean, default: false }) readonly fromExtendedFilters: boolean;
  @Prop({ type: Boolean, default: false }) readonly fromBulkEdit: boolean;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly value: CustomContactFieldInterface[];
  public customContactFieldPrepared: CustomContactFieldInterface[] = this.customContactFields;
  public ready: boolean = false;

  mounted() {
    // NOTE: there may be fields:
    // That do not yet exist for the contact as they have been added later in the center settings
    //there may be fields stored in the contact that no longer exist in the configuration.
    // reasons: the fields can be created/updated in config lately
    // So we have to prepare the list of fields to show.
    if (this.value) {
      this.customContactFieldPrepared = this.customContactFieldPrepared?.map(obj => {
        const fieldExists = this.value.find(item => item.id == obj.id);
        if (fieldExists) {
          return {
            ...obj,
            value:
              fieldExists.type === 'switch' ? this.toBoolean(fieldExists.value) : fieldExists.value,
          };
        }
        return {
          ...obj,
          value: null,
        };
      });
    }
    this.model = this.customContactFieldPrepared;
    this.ready = true;
  }
  // Update the value.
  modelChange($event) {
    if (!this.ready) {
      return;
    }
    this.customContactFieldPrepared = this.customContactFieldPrepared?.map(obj => {
      if (obj.id === $event.field.id) {
        return {
          ...obj,
          value: $event.field.type === 'switch' ? this.toBoolean($event.value) : $event.value,
        };
      }
      return obj;
    });

    this.model = this.customContactFieldPrepared;
  }

  toBoolean(value) {
    if (this.fromExtendedFilters || this.fromBulkEdit) {
      return value === null ? null : value === 'true' ? 'true' : 'false';
    }
    return value === 'false' || value === '0' || !value || value === 0 || value === false
      ? false
      : true;
  }

  get model() {
    return this.value;
  }

  set model(value) {
    this.$emit('input', value);
  }

  get customContactFields(): CustomContactFieldInterface[] {
    return this.$store.getters['centerSettings/customContactFields'] || [];
  }

  get tenantAlias() {
    return this.$route.params?.tenantAlias;
  }

  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }
}
